import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner6 from '../../assets/banner6.png'

import {
 Container,
 Title,
 Content,
 Table,
 FilterContainer,
 FilterContainerSelect
} from './styles'

export function ListaBeneficios() {
 const title = 'Clube do Parque'
 const subtitle = 'Lista de Benefícios'

 const fields = useMemo(
  () => [
   {
    id: 'Benefícios',
    imagem: String,
    name: String,
    category: String,
    subcategory: String,
    bio: String,
    text: String,
    floor: String,
    phone: String,
    site: String,
    instagram: String,
    facebook: String,
    whatsapp: String,
    status: Number
   }
  ],
  []
 )

 const {
  beneficios,
  setBeneficios,
  orderBy,
  setOrderBy,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(beneficios.length / limit)

 const handleOrderChange = event => {
  setOrderBy(event.target.value)
 }

 const loadBeneficios = useCallback(async () => {
  try {
   const response = await api.get(`clubedoparquepainel?order=${orderBy}`)

   setBeneficios(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar os benefícios')
  }
 }, [orderBy, setBeneficios])

 useEffect(() => {
  loadBeneficios()
 }, [loadBeneficios])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadBeneficios}
     fields={fields}
     name="clubedoparque"
     title="Benefício"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadBeneficios}
     id={id}
     name="clubedoparque"
     title="Benefício"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadBeneficios}
     id={id}
     name="clubedoparque"
     folder="clubedoparque"
     title="Benefício"
    />
   )}

   <Header title={title} subtitle={subtitle} />
   <Container>
    <FilterContainer>
     <Title>Gerenciador de Benefícios</Title>
     <FilterContainerSelect
      name="filter"
      id="filter"
      onChange={handleOrderChange}
     >
      <option value="mais_recentes">Mais Recentes</option>
      <option value="mais_antigos">Mais Antigos</option>
      <option value="asc">Ordem alfabética (A a Z)</option>
      <option value="desc">Ordem alfabética reversa (Z a A)</option>
      <option value="update_desc">Atualizações mais recentes</option>
      <option value="update_asc">Atualizações mais antigas</option>
     </FilterContainerSelect>
    </FilterContainer>
    {beneficios.length <= 0 ? (
     <>Nenhuma benefício cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Nome da loja</th>
         <th>Imagem</th>
         <th>Categoria</th>
         <th>Piso</th>
         <th>Telefone</th>
         <th>Site</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {beneficios &&
         beneficios.slice(offset, offset + limit).map(beneficio => (
          <tr key={beneficio.id}>
           <td>{beneficio.id}</td>
           <td>{beneficio.name}</td>
           <td>
            <div className="lojas-logo">
             {beneficio.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/clubedoparque/${beneficio.file}`}
               alt={beneficio.name}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{beneficio.category}</td>
           <td>{beneficio.floor}</td>
           <td>{beneficio.phone}</td>
           <td>{beneficio.site}</td>
           <td>
            {beneficio.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(beneficio.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(beneficio.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações dos logos</Title>
    <Content>
     <div>
      <img src={banner6} alt="Imagem de logo" />
      <h3>Imagem de logo</h3>
      <p>Formato: 500 x 500 pixels</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
